import ListaAlumnos from "views/Modulos/Toefl/ListaAlumnos.jsx";
import BuscarExpedientes from "views/Modulos/Toefl/Calificaciones/BuscarExpedientes.jsx";

import { People } from "@material-ui/icons";

import CookiesU from 'universal-cookie'
const cookies = new CookiesU();

const dashboardRoutes = [
  {
    path: "/Toefl",
    name: "Toefl",
    icon: People,
    component: ListaAlumnos,
    layout: "/toefl",
    idModulo: "16"
  },
  {
    path: "/BuscarExpedientes",
    name: "Calificaciones",
    icon: People,
    component: BuscarExpedientes,
    layout: "/toefl",
    idModulo: "16"
  },
]

let Permisos = localStorage.getItem("Permisos") == null ? { Modulo: [] } : JSON.parse(localStorage.getItem("Permisos"))
if (Permisos.length > 1) {
  Permisos = Permisos
} else {
  let aux = []
  aux.push(Permisos)
  Permisos = aux
}

var dashboardRoutesAccess = [];

for (var keyRoutes = 0; keyRoutes < dashboardRoutes.length; keyRoutes++) {
  if (Permisos.find(permiso => permiso.NumeroModulo == dashboardRoutes[keyRoutes].idModulo)) {
    dashboardRoutesAccess.push(dashboardRoutes[keyRoutes]);
  }
}
export default dashboardRoutesAccess;